import React from 'react';

import ContactUs from './ContactUs';
import { Order } from '../../types';
import PageView from '../PageView';

interface Props {
  order?: Order;
  message: string;
  children?: React.ReactNode;
}

function ErrorView(props: Props) {
  const { order, message, children } = props;

  return (
    <PageView heading="error_heading" order={order} message={message} intent="info">
      <ContactUs>error_contactUs</ContactUs>
      {children}
    </PageView>
  );
}

export default React.memo(ErrorView);
